<template>
  <div class="tiptap-vuetify-image-upload-area">
    <input
      id="tiptap-vuetify-image-upload-area__input-file"
      type="file"
      accept="image/*"
      multiple
    >

    <label
      class="tiptap-vuetify-image-upload-area-holder"
      for="tiptap-vuetify-image-upload-area__input-file"
    >
      <div>
        <svg
          class="tiptap-vuetify-image-upload-area-holder__icon"
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="43"
          viewBox="0 0 50 43"
        >
          <path d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z" />
        </svg>
        <br>
        <h3><translate>Choose a file(s) or drag it here.</translate></h3>
      </div>
    </label>
  </div>
</template>

<script>
import MediaService from "@/services/MediaService"
const HOLDER_CLASS = 'tiptap-vuetify-image-upload-area-holder'
export default {
  name: "TiptapImageUpload",
  data() {
    return {
      
    };
  },
  methods: {
    async filesSelected (files) {
      if(files.length == 0) return
      const uploadFiles = Object.assign([], files);
      const compressedFiles = []
      for(let file of uploadFiles) {
        console.log('compressing file', file)
        file = await this.compressFile(file);
        compressedFiles.push(file)
        console.log('compressing file done', file)
      }
      const formData = new FormData();
      compressedFiles.forEach(file => {
        formData.append("photoFiles[]", file);
      })
      const result = await MediaService.uploadUserMedia(formData);
      result.forEach(media => {
        this.$emit('select-file', {
          src: media.path,
          alt: media.description
        })
      })
    },
    selectImage(img) {
      this.$emit('select-file', img);
    },
    async compressFile(file) {
      console.log('start compress file', file.size)
      const image = new Image();
      const fileName = file.name;
      const canvas = document.createElement('canvas');
      const canvasContext = canvas.getContext("2d");
      canvasContext.clearRect(0, 0, canvas.width, canvas.height);
      image.src = URL.createObjectURL(file);
      await new Promise((resolve, reject) => {
        image.onload = () => {resolve()}
      })
      
      console.log('image loaded, with dimension', image.width, image.height)
      const ratio = image.width / image.height
      const width = Math.min(image.width, 800)
      const height = width / ratio;
      canvasContext.canvas.width = width;
      canvasContext.canvas.height = height;
      canvasContext.drawImage(image, 0, 0, width, height);

      let finalBlob = await new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => { resolve(blob) },
          "image/jpeg",
          0.95
        );
      })
      
      const compressedFile = new File([finalBlob], 'vintage', {
        type: "image/jpeg",
        lastModified: Date.now()
      });
      console.log('compressedFile created', compressedFile.size)
      if(compressedFile.size <= 200000) {
        return compressedFile
      }
      const compressRatio = 200000 / compressedFile.size
      console.log(compressRatio)
      finalBlob = await new Promise((resolve, reject) => {
        canvas.toBlob(
          blob => resolve(blob),
          "image/jpeg",
          compressRatio
        );
      });
      return new File([finalBlob], 'vintage', {
        type: "image/jpeg",
        lastModified: Date.now()
      });
    }
  },
  mounted () {
    const holder = document.querySelector('.' + HOLDER_CLASS)
    const input = document.querySelector('#tiptap-vuetify-image-upload-area__input-file')

    input.addEventListener('change', e => {
      this.filesSelected(e.target.files)
      holder.classList.remove(HOLDER_CLASS + '--dragover')

      e.target.value = ''
    })
    holder.addEventListener('dragover', () => {
      holder.classList.add(HOLDER_CLASS + '--dragover')
      return false
    })

    const dragleaveOrEndHandler = () => {
      holder.classList.remove(HOLDER_CLASS + '--dragover')
      return false
    }

    holder.addEventListener('dragleave', dragleaveOrEndHandler)
    holder.addEventListener('dragend', dragleaveOrEndHandler)
    holder.addEventListener('drop', e => {
      e.preventDefault()
      this.filesSelected(e.dataTransfer.files)
    })
  }
}
</script>

<style lang="scss">
.tiptap-vuetify-image-upload-area-holder {
  height: 150px !important;
  .tiptap-vuetify-image-upload-area-holder__icon {
    height: 40px !important;
    margin-bottom: 10px !important;
  }
}
</style>